import React from "react"
import { ReactComponent as ClosedBook } from "../assets/animation-1.svg"
import { ReactComponent as OpenBook } from "../assets/animation-2.svg"
import { ReactComponent as Sprinkle } from "../assets/animation-3.svg"

function Loading() {
    return (
        <div className="loadingContainer">
            <ClosedBook className="loading1" />
            <OpenBook className="loading2" />
            <Sprinkle className="loading3" />
        </div>
    )
}

export default Loading
